import App from 'app/app.js';

function VisualMerchandiseStore() {
  var visualMerchandise = null;
  var poseCount = 0;

  this.clearAll = function () {
    visualMerchandise = null;
  };

  this.loadVisualMerchandise = function (visualMerchandiseIn) {
    visualMerchandise = visualMerchandiseIn || {};
    if (visualMerchandise.poseCount) {
      poseCount = visualMerchandise.poseCount;
    }
  };

  this.getVisualMerchandise = function () {
    return visualMerchandise;
  };
  this.getPoseCount = function () {
    return poseCount;
  };
}

App.service('VisualMerchandiseStore', [VisualMerchandiseStore]);
